"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOpenPromise = void 0;
function createOpenPromise() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    promise.resolvedValue = null;
    let isResolvedOrRejected = false;
    promise.resolve = (value) => {
        if (!isResolvedOrRejected) {
            resolve(value);
            promise.resolvedValue = value;
            isResolvedOrRejected = true;
        }
    };
    promise.reject = (err) => {
        if (!isResolvedOrRejected) {
            reject(err);
            isResolvedOrRejected = true;
        }
    };
    return promise;
}
exports.createOpenPromise = createOpenPromise;
